import React, { useMemo } from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { compareStrings, nullSafeGet } from '../../utils/DataAccessUtils';
import DateTimeHover from '../date_time_component/DateTime';
import { getBidderCummulativeStatus, RFP_STATUS } from '../../constants/BidderStatuses';
import { connect } from 'react-redux';
import { UserName } from '../name_component/user/UserNameComponent';
import CummulativeBidderStatusDisplay from '../rfp_row_display/CummulativeBidderStatusDisplay';
import { isDatePastDue } from '../../utils/DataFormatterUtils';
import PastDue from '../work_order_row_display_simple/PastDue';

require('../rfp_row_display/RFPRowDisplay.less');

const BidderRowDisplay: React.FC<any> = ({ bidder, currentUser, ...props }) => {
	const actionName = useMemo(() => {
		switch (nullSafeGet('requestForProposal.status', bidder)) {
			case RFP_STATUS.ACTIVE:
				return 'Published';
			case RFP_STATUS.CLOSED:
				return 'Closed';
			case RFP_STATUS.AWARD:
				return 'Awarded';
			default:
				return '';
		}
	}, [bidder]);

	const rfpStatusDetail = useMemo(
		() =>
			nullSafeGet('requestForProposal.publishedOrClosedOrAwardedByContact', bidder) ||
			nullSafeGet('requestForProposal.publishedOrClosedOrAwardedAt', bidder) ? (
				<>
					<span>
						{`${actionName}`}
						<>
							{nullSafeGet('requestForProposal.publishedOrClosedOrAwardedByContact', bidder) ? (
								<span>
									{' by '}
									<UserName
										contact={bidder.requestForProposal.publishedOrClosedOrAwardedByContact}
										mode={'inline'}
										placement={'top'}
									/>
								</span>
							) : (
								''
							)}
						</>
					</span>
					<>
						{nullSafeGet('requestForProposal.publishedOrClosedOrAwardedAt', bidder) ? (
							<span>
								{' '}
								<DateTimeHover
									timeZone={nullSafeGet('workorder.location.timeZoneId', bidder)}
									timestamp={bidder.requestForProposal.publishedOrClosedOrAwardedAt}
								/>
							</span>
						) : null}
					</>
				</>
			) : null,
		[actionName, bidder]
	);

	return (
		<div className="rfpRowDisplay" {...props}>
			<div>
				<div className="rfpRowDisplay__rowTitle">
					<Ellipsis tooltip={true} length={64}>
						{nullSafeGet('requestForProposal.title', bidder)}
					</Ellipsis>
				</div>
				<div className="rfpRowDisplay__rowSubtitle">
					{nullSafeGet('workOrder.location.name', bidder) ? (
						<div className="rfpRowDisplay__rowInlineGroup">
							<span className="rowGrayChip">
								<i className="icons8-font icons8-location-marker" />
								<span>{nullSafeGet('workOrder.location.name', bidder)}</span>
							</span>
						</div>
					) : null}
					<div className="rfpRowDisplay__rowInlineGroup">
						<CummulativeBidderStatusDisplay status={getBidderCummulativeStatus(bidder)} />
					</div>
					{nullSafeGet('workOrder.problemType.hierarchyName', bidder) ? (
						<div className="rfpRowDisplay__rowInlineGroup">
							<i className="icons8-font icons8-maintenance-filled" />
							{nullSafeGet('workOrder.problemType.hierarchyName', bidder)}
						</div>
					) : null}
					<div className="rfpRowDisplay__rowInlineGroup py-2">
						<span>WO #{nullSafeGet('workOrderId', bidder)}</span>
					</div>
				</div>
				<div className="rfpRowDisplay__rowSubtitle mt-2">
					{!compareStrings(nullSafeGet('requestForProposal.status', bidder), RFP_STATUS.AWARD) ? (
						isDatePastDue(nullSafeGet('requestForProposal.dueDate', bidder)) ? (
							<PastDue
								className="mr-4"
								dueDate={nullSafeGet('requestForProposal.dueDate', bidder)}
								showTime={false}
								showYear={false}
							/>
						) : (
							<span className="mr-4">
								Due{' '}
								<DateTimeHover
									timestamp={nullSafeGet('requestForProposal.dueDate', bidder)}
									showTime={false}
									showYear={false}
								/>
							</span>
						)
					) : null}
					{compareStrings(nullSafeGet('requestForProposal.status', bidder), RFP_STATUS.DRAFT) && (
						<span>
							Created{' '}
							<DateTimeHover
								timeZone={nullSafeGet('workorder.location.timeZoneId', bidder)}
								timestamp={nullSafeGet('requestForProposal.createdAt', bidder)}
							/>
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(BidderRowDisplay);
